import type { PImage } from '../../engine/aliases'
import { assert } from '../../lib/assert-sidecar'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import type { IStevieText2 } from '../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageLayers } from './voyageLayers-sidecar'
import type { IVoyageSystemState } from './voyageSystems'
import { EVoyageTile, IVoyageTileData } from './voyageTileData'
import { voyageTileData } from './voyageTileData-sidecar'

export interface IVoyageTilemapPart {
  i: number
  j: number
  x: number
  y: number
  image1: PImage
  image2: PImage | null
  image3: PImage | null
  imageBreach: PImage | null
  tile1: IVoyageTileData
  colorIdx1: number
  subTileIdx1: number
  tile2: IVoyageTileData
  colorIdx2: number
  subTileIdx2: number

  tile3: IVoyageTileData
  colorIdx3: number
  subTileIdx3: number
  text3: string

  text: IStevieText2 | null

  fire: IVoyageCrew | null
  breach: IVoyageCrew | null
  system: IVoyageSystemState | null
  // TODO: can move on?
}

export function create(
  i: number,
  j: number,
  x: number,
  y: number,
): IVoyageTilemapPart {
  let image1 = spritesUtil.createImage(
    voyageLayers.getLayers().ship1,
    sprites.voyTileChecker1[0],
  )
  image1.tint = voyageColors.g2

  let tile1 = voyageTileData.get(EVoyageTile.CheckerBottom)
  let tile2 = voyageTileData.get(EVoyageTile.Null2)
  let tile3 = voyageTileData.get(EVoyageTile.Null3)

  let obj: IVoyageTilemapPart = {
    i,
    j,
    x,
    y,
    image1,
    image2: null,
    image3: null,
    imageBreach: null,
    tile1,
    colorIdx1: 0,
    subTileIdx1: 0,
    tile2,
    colorIdx2: 0,
    subTileIdx2: 0,
    tile3,
    colorIdx3: 0,
    subTileIdx3: 0,
    text3: '',
    text: null,
    fire: null,
    breach: null,
    system: null,
  }
  moveToXY(obj, x, y)
  return obj
}

export function moveToXY(obj: IVoyageTilemapPart, x: number, y: number) {
  obj.x = x
  obj.y = y
  obj.image1.x = x
  obj.image1.y = y
  if (obj.image2) {
    obj.image2.x = x
    obj.image2.y = y
  }
  if (obj.image3) {
    obj.image3.x = x
    obj.image3.y = y
  }
}

export function setTile(
  obj: IVoyageTilemapPart,
  //layer: number,
  data: IVoyageTileData,
  subTileIdx: number,
  colorIdx: number,
) {
  let img = obj.image2
  let layer = data.layer

  subTileIdx = mathUtils.wrapIndex(subTileIdx, data.frames)
  colorIdx = mathUtils.wrapIndex(colorIdx, data.colors)

  if (layer === 1) {
    img = obj.image1
    obj.tile1 = data
    obj.subTileIdx1 = subTileIdx
    obj.colorIdx1 = colorIdx
  }
  if (layer === 2) {
    if (!obj.image2 && !data.isNull) {
      obj.image2 = spritesUtil.createImage(
        voyageLayers.getLayers().ship2,
        sprites.voyTileNull[0],
      )
      obj.image2.x = obj.x
      obj.image2.y = obj.y
    }

    img = obj.image2
    obj.tile2 = data
    obj.subTileIdx2 = subTileIdx
    obj.colorIdx2 = colorIdx
  }
  if (layer === 3) {
    if (!obj.image3 && !data.isNull) {
      obj.image3 = spritesUtil.createImage(
        voyageLayers.getLayers().ship3,
        sprites.voyTileNull[0],
      )
      obj.image3.x = obj.x
      obj.image3.y = obj.y
    }

    img = obj.image3
    obj.tile3 = data
    obj.subTileIdx3 = subTileIdx
    obj.colorIdx3 = colorIdx
  }
  if (!data.isNull) {
    assert.notNil(img, 'somehow image is null')
    spritesUtil.setPackedFrame(img, data.frames[subTileIdx])
    img.tint = data.colors[colorIdx]
    img.visible = true
  } else {
    if (img) {
      img.visible = false
    }
  }
}

export function setText(obj: IVoyageTilemapPart, text: string) {
  obj.text3 = text

  if (!obj.text && text) {
    obj.text = stevieTexts2.create(
      echoFonts.getData().font4,
      0,
      0,
      voyageLayers.getLayers().ship3,
    )
    stevieTexts2.setScale(obj.text, 4)
  }
  if (obj.text) {
    stevieTexts2.setText(obj.text, text)
    stevieTexts2.moveTo(obj.text, obj.x, obj.y)
  }
}

// export function setHullBreach(obj: IVoyageTilemapPart, isBreach: boolean) {
//   if (isBreach) {
//     if (!obj.imageBreach) {
//       obj.imageBreach = spritesUtil.createImage(
//         voyageLayers.getLayers().ship3,
//         sprites.voyTileChecker2[0],
//       )
//       obj.imageBreach.x = obj.x
//       obj.imageBreach.y = obj.y
//       obj.imageBreach.tint = voyageColors.damage
//     }
//   } else {
//     if (obj.imageBreach) {
//       obj.imageBreach.destroy()
//       obj.imageBreach = null
//     }
//   }
// }
